export interface ValidateDescription {
    type: ValidateTypeDescription;
    field: string;
    operator: ValidateOperatorTypeDescription;
    value: string | number | boolean | null;
    expression: string;
    message: string;
}

export enum ValidateTypeDescription {
    RequiredIf = 'requiredif',
    Comparator = 'comparator',
    Condition = 'condition',
    BankData = 'bankdata'
}

export enum ValidateOperatorTypeDescription {
    EqualTo = '=',
    MoreThan = '>',
    LessThan = '<',
    MoreThanOrEqualTo = '>=',
    LessThanOrEqualTo = '<='
}

export enum ValidatorTypeDescription {
    Required,
    Min,
    Max,
    MinLength,
    MaxLength,
    Regexp
}